import React from 'react'
import {
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav
} from 'reactstrap'
import { Link } from 'react-router-dom'
import '../../../styling/glyphicons/glyphicons.css'
import './IPAMenu.css'

const IPAMenu = (props) => {
  return (
    <Dropdown nav inNavbar>
      <DropdownToggle nav caret className="glyphicons glyphicons-beer">
        <p className="nav-link-p">{props.label}</p>
      </DropdownToggle>
      <Nav>
        <DropdownMenu>
          <DropdownItem>
            <Link to="/ui2/results" className="glyphicons glyphicons-list-alt">
              Results
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link
              to="/ui2/analyzers"
              className="glyphicons glyphicons-screenshot"
            >
              Analyzers
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to="/ui2/scripts" className="glyphicons glyphicons-file">
              Scripts
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to="/ui2/datasets" className="glyphicons glyphicons-package">
              Datasets
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link
              to="/ui2/howitworks"
              className="glyphicons glyphicons-info-sign"
            >
              How it Works
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Nav>
    </Dropdown>
  )
}

export default IPAMenu
